import { Button, Typography } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import ModalV2 from '/@/components/bayer/modal-v2';
import { _ } from '/@/locale';

/**
 * Confirmation before deleting a registry from the timeline. Stays open (with an error toast)
 * if the delete fails, and closes once it succeeds.
 */
export const ConfirmDeleteModal = ({
    open,
    onClose,
    onConfirm,
    title,
    message,
    isDeleting = false,
}: {
    open: boolean;
    onClose: () => void;
    onConfirm: () => Promise<unknown>;
    title: string;
    message: string;
    isDeleting?: boolean;
}) => {
    const handleConfirm = async () => {
        try {
            await onConfirm();
        } catch {
            enqueueSnackbar(_('No se pudo eliminar el registro. Intentá nuevamente.'), { variant: 'error' });
            return;
        }
        onClose();
    };

    return (
        <ModalV2
            open={open}
            onClose={onClose}
            title={title}
            bodyProps={{ alignItems: 'stretch', textAlign: 'left' }}
            // Buttons go straight into ModalV2Actions so they get the standard modal layout
            // (spacing, stacked on mobile), as in the other delete modals.
            actionsProps={{ justifyContent: 'end' }}
            actions={
                <>
                    <Button variant='text' color='secondary' onClick={onClose} disabled={isDeleting}>
                        {_('Cancelar')}
                    </Button>
                    <Button variant='contained' color='secondary' onClick={handleConfirm} disabled={isDeleting}>
                        {_('Eliminar')}
                    </Button>
                </>
            }
        >
            <Typography variant='body2' color='primary'>
                {message}
            </Typography>
        </ModalV2>
    );
};
